import IntercomSDK from "@intercom/messenger-js-sdk";

import { getEnvironmentVariable } from "@/common/services/env";

const Intercom = ({
  user,
}: {
  user: {
    name: string;
    email: string;
    phone?: string;
  };
}) => {
  const appId = getEnvironmentVariable("INTERCOM_APP_ID");

  if (!appId) {
    return null;
  }

  IntercomSDK({
    app_id: appId,
    email: user.email,
    name: user.name,
    phone: user.phone,
    region: "eu",
    vertical_padding: 70,
  });

  return null;
};

export { Intercom };
